import { cn } from '~/src/lib/utils'
import type { HubSectionComponentProps, HubStatCalloutSection } from './types'

export function HubStatCallout({
  section,
}: HubSectionComponentProps<HubStatCalloutSection>) {
  if (section.stats.length === 0) return null

  return (
    <section id={section.id} className='flex flex-col gap-4'>
      {section.title && (
        <h2 className='font-display text-2xl font-bold leading-8 text-foreground'>
          {section.title}
        </h2>
      )}
      {section.dek && (
        <p className='text-base leading-6 text-foreground-secondary'>
          {section.dek}
        </p>
      )}
      <dl
        className={cn(
          'grid grid-cols-2 gap-3',
          section.stats.length >= 3 && 'md:grid-cols-3',
          section.stats.length >= 4 && 'lg:grid-cols-4'
        )}
      >
        {section.stats.map((stat, index) => (
          <div
            key={`${stat.label}-${index}`}
            className='flex flex-col gap-1 rounded-2xl border border-border bg-accent p-4'
          >
            <dt className='order-2 text-sm font-medium text-foreground-secondary'>
              {stat.label}
            </dt>
            <dd className='order-1 font-display text-3xl font-bold leading-9 tracking-tight text-foreground md:text-4xl'>
              {stat.value}
            </dd>
            {stat.helpText && (
              <p className='order-3 text-xs leading-5 text-foreground-tertiary'>
                {stat.helpText}
              </p>
            )}
          </div>
        ))}
      </dl>
    </section>
  )
}
